import { css } from 'styled-components';
import { WithFontHead, defaultFont } from 'styles/commonCss';

import { mqSmallMin } from 'styled/tools/media-queries';

/*
  This can be later used in a createGlobalStyle in our _app.tsx to
  apply the styling to the entire application, instead of importing
  _fonts.scss in app.scss
*/

export const Fonts = css`
  * {
    ${defaultFont}
    font-size: 16px;
    font-weight: 400;
    letter-spacing: normal;
    line-height: 1.5;
  }

  h1 {
    font-size: 50px;
  }

  h2 {
    font-size: 40px;
  }

  h3 {
    font-size: 30px;
  }

  h4 {
    font-size: 26px;
  }

  h6 {
    font-size: 14px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    ${WithFontHead}
  }

  h1,
  h2 {
    letter-spacing: var(--flag-letter-spacing-1);
    @media ${mqSmallMin} {
      letter-spacing: var(--flag-letter-spacing-2);
    }
  }

  small {
    font-size: 13px;
  }

  b,
  strong {
    font-weight: 500;
  }

  i {
    font-style: italic;
  }

  .underline {
    text-decoration: underline;
  }
`;
